import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enServices from './locales/en/services.json';
import enTransactions from './locales/en/transactions.json';
import enWebhooks from './locales/en/webhooks.json';
import enIqServices from './locales/en/iq-services.json';
import enDashboard from './locales/en/dashboard.json';
import enErrors from './locales/en/errors.json';
import enHelp from './locales/en/help.json';
import enWebhookConfig from './locales/en/webhook-config.json';
import enSubscriptions from './locales/en/subscriptions.json';
import enMerchants from './locales/en/merchants.json';
import enRouting from './locales/en/routing.json';
// Issue #318: Namespace mno-ip-ranges
import enMnoIpRanges from './locales/en/mno-ip-ranges.json';
// Spec 514/332: Namespace merchant-assets
import enMerchantAssets from './locales/en/merchant-assets.json';
// Spec 340: Namespace service-theme (Inline-Theme-Editor)
import enServiceTheme from './locales/en/service-theme.json';
// Devportal-Track Mount-Point (Spec 247 §5): Namespace devportal
import enDevportal from './locales/en/devportal.json';
// Spec 344: Namespace iq-service-inventory (merchant-nested; distinct from iq-services)
import enIqServiceInventory from './locales/en/iq-service-inventory.json';
// Issue #394 (WP1): Namespace auth (Login/MFA/Passwort)
import enAuth from './locales/en/auth.json';
// Issue #396 (WP2): Namespace users (Benutzerverwaltung)
import enUsers from './locales/en/users.json';

import deCommon from './locales/de/common.json';
import deServices from './locales/de/services.json';
import deTransactions from './locales/de/transactions.json';
import deWebhooks from './locales/de/webhooks.json';
import deIqServices from './locales/de/iq-services.json';
import deDashboard from './locales/de/dashboard.json';
import deErrors from './locales/de/errors.json';
import deHelp from './locales/de/help.json';
import deWebhookConfig from './locales/de/webhook-config.json';
import deSubscriptions from './locales/de/subscriptions.json';
import deMerchants from './locales/de/merchants.json';
import deRouting from './locales/de/routing.json';
import deMnoIpRanges from './locales/de/mno-ip-ranges.json';
import deMerchantAssets from './locales/de/merchant-assets.json';
import deServiceTheme from './locales/de/service-theme.json';
import deDevportal from './locales/de/devportal.json';
import deIqServiceInventory from './locales/de/iq-service-inventory.json';
import deAuth from './locales/de/auth.json';
import deUsers from './locales/de/users.json';
// Spec 429 Increment D: Analytics-Reports (QuickSight-Embed)
import enReports from './locales/en/reports.json';
import deReports from './locales/de/reports.json';
// Spec 493: Payment-Link Verwaltung (Provisioning-API v2.0 Consumer)
import enPaymentLink from './locales/en/payment-link.json';
import dePaymentLink from './locales/de/payment-link.json';
// Spec 528: Audit-Trail-Plattform-Sicht
import enAudit from './locales/en/audit.json';
import deAudit from './locales/de/audit.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        services: enServices,
        transactions: enTransactions,
        webhooks: enWebhooks,
        'iq-services': enIqServices,
        dashboard: enDashboard,
        errors: enErrors,
        help: enHelp,
        'webhook-config': enWebhookConfig,
        subscriptions: enSubscriptions,
        merchants: enMerchants,
        routing: enRouting,
        'mno-ip-ranges': enMnoIpRanges,
        'merchant-assets': enMerchantAssets,
        'service-theme': enServiceTheme,
        devportal: enDevportal,
        'iq-service-inventory': enIqServiceInventory,
        auth: enAuth,
        users: enUsers,
        reports: enReports,
        'payment-link': enPaymentLink,
        audit: enAudit,
      },
      de: {
        common: deCommon,
        services: deServices,
        transactions: deTransactions,
        webhooks: deWebhooks,
        'iq-services': deIqServices,
        dashboard: deDashboard,
        errors: deErrors,
        help: deHelp,
        'webhook-config': deWebhookConfig,
        subscriptions: deSubscriptions,
        merchants: deMerchants,
        routing: deRouting,
        'mno-ip-ranges': deMnoIpRanges,
        'merchant-assets': deMerchantAssets,
        'service-theme': deServiceTheme,
        devportal: deDevportal,
        'iq-service-inventory': deIqServiceInventory,
        auth: deAuth,
        users: deUsers,
        reports: deReports,
        'payment-link': dePaymentLink,
        audit: deAudit,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
